import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import { IoIosEye } from "react-icons/io";
import { useEffect, useState } from "react";
import { fetchServices } from "../locales/services";
import { TbEyeQuestion, TbEyeExclamation, TbEyeSearch } from "react-icons/tb";
import { RiGlassesLine } from "react-icons/ri";
import { FiChevronsRight } from "react-icons/fi";
const MyopiaCenter = ({ mediaUrls }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [showIcons, setShowIcons] = useState(true);

  const handleServiceClick = (service) => {
    if (!service) {
      navigate("/services");
    } else {
      navigate("/service-details", {
        state: { service },
        serviceId: service.sortOrder,
      });
    }
  };

  const Bullet = ({ text }) => (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
        marginBottom: "6px",
      }}
    >
      <IoIosEye style={{ flexShrink: 0, color: "color", marginTop: "4px" }} />
      <span style={{ color: "color", lineHeight: "1.4" }}>{text}</span>
    </div>
  );

  useEffect(() => {
    const loadServices = async () => {
      try {
        const fetchedServices = await fetchServices();
        setServices(fetchedServices);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    loadServices();
  }, []);

  const tiles = [
    {
      title: t("home.myopiaSection.whatIsMyopiaTitle"),
      icon: <TbEyeQuestion />,
      desc: (
        <div>
          <p style={{ marginBottom: "10px" }}>
            {t("home.myopiaSection.whatIsMyopiaDesc")}
          </p>
          <Bullet text={t("home.myopiaSection.whatIsMyopiaBullet1")} />
          <Bullet text={t("home.myopiaSection.whatIsMyopiaBullet2")} />
        </div>
      ),
    },
    {
      title: t("home.myopiaSection.scienceBehindMyopiaTitle"),
      icon: <TbEyeSearch />,
      desc: (
        <div>
          <Bullet text={t("home.myopiaSection.scienceBehindMyopiaBullet1")} />
          <Bullet text={t("home.myopiaSection.scienceBehindMyopiaBullet2")} />
        </div>
      ),
    },
    {
      title: t("home.myopiaSection.causesRisksTitle"),
      icon: <TbEyeExclamation />,
      desc: (
        <div>
          <Bullet text={t("home.myopiaSection.causesRisksBullet1")} />
          <Bullet text={t("home.myopiaSection.causesRisksBullet2")} />
          <Bullet text={t("home.myopiaSection.causesRisksBullet3")} />
        </div>
      ),
    },
    {
      title: t("home.myopiaSection.treatmentsTitle"),
      icon: <RiGlassesLine />,
      desc: (
        <div>
          <Bullet text={t("home.myopiaSection.treatmentsBullet1")} />
          <Bullet text={t("home.myopiaSection.treatmentsBullet2")} />
          <Bullet text={t("home.myopiaSection.treatmentsBullet3")} />
          <Bullet text={t("home.myopiaSection.treatmentsBullet4")} />
        </div>
      ),
    },
  ];

  return (
    <section
      className="service-section bg-color-fourth section-gap-top"
      style={{
        marginBottom: "100px",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="section-heading heading-white text-center">
              <h2
                style={{
                  fontSize: "45px",
                  textAlign: "center",
                  color: "white",
                  marginBottom: "6px",
                }}
              >
                {t("home.myopiaSection.title")}
              </h2>
              <span
                className="tagline"
                style={{
                  fontSize: "29px",
                  color: "white",
                  fontWeight: "normal",
                  marginBottom: "50px",
                  marginTop: "18px",
                }}
              >
                {t("home.myopiaSection.subtitle")}
              </span>
            </div>
          </div>
        </div>

        <div className="iconic-boxes-big-image">
          <div className="row justify-content-lg-between justify-content-center first-row">
            {tiles.slice(0, 2).map((tile, i) => (
              <div
                key={i}
                className={`col-xl-3 col-lg-4 col-md-6 col-sm-8 ${
                  i === 0 ? "first-column" : "second-column"
                }`}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <div
                  className={`single-iconic-item wow ${
                    i === 0 ? "fadeInRight" : "fadeInLeft"
                  }`}
                  data-wow-delay="0.4s"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                    minHeight: "220px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 30px rgba(0, 0, 0, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(0, 0, 0, 0.1)";
                  }}
                  onClick={() => handleServiceClick()}
                >
                  {showIcons && (
                    <div
                      style={{
                        fontSize: "70px",
                        marginBottom: "10px",
                        color: "var(--color-doctor)",
                        padding: "0",
                        margin: 0,
                      }}
                    >
                      {tile.icon}
                    </div>
                  )}
                  <h4 className="title">{tile.title}</h4>
                  <p>{tile.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="row justify-content-lg-between justify-content-center second-row">
            {tiles.slice(2, 4).map((tile, i) => (
              <div
                key={i}
                className={`col-xl-3 col-lg-4 col-md-6 col-sm-8 ${
                  i === 0 ? "first-column" : "second-column"
                }`}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <div
                  className={`single-iconic-item wow ${
                    i === 0 ? "fadeInLeft" : "fadeInRight"
                  }`}
                  data-wow-delay="0.5s"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                    minHeight: "220px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 30px rgba(0, 0, 0, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(0, 0, 0, 0.1)";
                  }}
                  onClick={() => handleServiceClick()}
                >
                  {showIcons && (
                    <div
                      style={{
                        fontSize: "70px",
                        marginBottom: "10px",
                        color: "var(--color-doctor)",
                        padding: "0",
                        margin: 0,
                      }}
                    >
                      {tile.icon}
                    </div>
                  )}
                  <h4 className="title">{tile.title}</h4>
                  <p>{tile.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              style={{
                padding: "10px 30px",
                fontSize: "1rem",
                backgroundColor: "white",
                color: "var(--color-fourth)",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "0.3s",
                marginTop: "20px",
                textDecoration: "none",
                textTransform: "none",
                fontWeight: 700,
              }}
              onClick={() => {
                const targetService = services[14];
                if (targetService) {
                  navigate("/service-details", {
                    state: { service: targetService },
                    serviceId: targetService.sortOrder,
                  });
                } else {
                  navigate("/services");
                }
              }}
            >
              {t("home.knowMore")} <FiChevronsRight />
            </button>
          </div>{" "}
          <img
            src={mediaUrls.myopiaInfo}
            className="big-image"
            style={{
              width: "100%",
              height: "700px",
              objectFit: "contain",
            }}
            alt={t("home.myopiaSection.imageMyopiaInfoAlt")}
          />
          <img
            src="assets/img/iconic-box/border-line.png"
            alt={t("home.myopiaSection.imageBorderAlt")}
            className="border-image"
          />
        </div>
      </div>
    </section>
  );
};

export default MyopiaCenter;
